import { styled } from '@mui/material';

import { getPctgColor } from '»utils/pctgColors';

export const Wrapper = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isSelected' && prop !== 'variationPctg',
})(({ theme, isSelected, variationPctg }) => ({
  width: '280px',
  border: `solid 1px ${theme.palette.colors.borderLine}`,
  backgroundColor: isSelected
    ? theme.palette.colors.selectedAndDetailBackground
    : theme.palette.colors.secondaryBackground,
  borderRadius: '5px',
  borderTopRightRadius: '8px',
  borderBottomRightRadius: '8px',
  marginTop: '24px',
  display: 'flex',
  flexDirection: 'row',
  gap: 0,
  justifyContent: 'space-evenly',
  position: 'relative',
  '&::before': {
    content: `''`,
    position: 'absolute',
    backgroundColor: getPctgColor(variationPctg, theme),
    width: '8px',
    height: '100%',
    bottom: 0,
    left: 0,
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
  },
  '&:hover': {
    backgroundColor: theme.palette.colors.selectedAndDetailBackground,
    cursor: 'pointer',
  },
}));
